import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Section2 = ({ url }) => {
  // color transition
  const [currentColor, setCurrentColor] = useState("black");

  useEffect(() => {
    const handle_Scroll = () => {
      const panels = document.querySelectorAll(".panel");
      const scroll = window.scrollY + window.innerHeight / 4.5;

      panels.forEach((panel) => {
        if (
          panel.offsetTop <= scroll &&
          panel.offsetTop + panel.offsetHeight > scroll
        ) {
          const newColor = panel.dataset.color;
          setCurrentColor(newColor);
        }
      });
    };

    window.addEventListener("scroll", handle_Scroll);
    return () => {
      window.removeEventListener("scroll", handle_Scroll);
    };
  }, []);

  // for read more column
  const [displayText1, setDisplayText1] = useState("none");
  const [buttonText1, setButtonText1] = useState("Read More");

  const [displayText2, setDisplayText2] = useState("none");
  const [buttonText2, setButtonText2] = useState("Read More");

  const [displayText3, setDisplayText3] = useState("none");
  const [buttonText3, setButtonText3] = useState("Read More");

  const [displayText4, setDisplayText4] = useState("none");
  const [buttonText4, setButtonText4] = useState("Read More");

  const handleButtonClick1 = () => {
    if (displayText1 === "none") {
      setDisplayText1("block");
      setButtonText1("Read Less");
    } else {
      setDisplayText1("none");
      setButtonText1("Read More");
    }
  };

  const handleButtonClick2 = () => {
    if (displayText2 === "none") {
      setDisplayText2("block");
      setButtonText2("Read Less");
    } else {
      setDisplayText2("none");
      setButtonText2("Read More");
    }
  };

  const handleButtonClick3 = () => {
    if (displayText3 === "none") {
      setDisplayText3("block");
      setButtonText3("Read Less");
    } else {
      setDisplayText3("none");
      setButtonText3("Read More");
    }
  };

  const handleButtonClick4 = () => {
    if (displayText4 === "none") {
      setDisplayText4("block");
      setButtonText4("Read Less");
    } else {
      setDisplayText4("none");
      setButtonText4("Read More");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setDisplayText1("none");
        setDisplayText2("none");
        setDisplayText3("none");
        setDisplayText4("none");
      } else {
        setDisplayText1("block");
        setDisplayText2("block");
        setDisplayText3("block");
        setDisplayText4("block");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial display state based on window width

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="services-section-2">
      <div className="transition-container sect-2-container">
        <div
          className={`panel color-${currentColor} black-panel panel-1`}
          data-color="black"
        >
          <div className="container panel-1-container">
            <div className="services-desc">
              <h2 className="title">What We Do</h2>
              <h5 className="txt">
                {/* From AI-Powered innovation, Customize Website & App Development to 
                Social Media Marketing and Branding, we've got it all! 
                <br />
                <br /> */}
                At ExD Digital, complex business challenges are turned into scalable 
                digital solutions. The focus is on building, enhancing, and scaling 
                digital capabilities that help businesses move faster, operate smarter, 
                and grow sustainably.
                <br />
                <br />
                From custom-built software and AI-driven automation to high-impact digital 
                experiences and performance-led marketing, ExD Digital partners with businesses 
                at every stage, from early ideas to enterprise-scale execution. Each engagement 
                is designed around clear outcomes: efficiency, growth, and measurable impact.
              </h5>
            </div>
          </div>
        </div>
        <div
          className={`panel color-${currentColor} white-panel panel-2`}
          data-color="white"
        >
          <div className="container panel-2-container" id="services-section">
            <div className="row panel-2-row">
              <div className="col-lg-6 col-md-6 col-12 service">
                <div className="srvc-img">
                  <img
                    loading="lazy"
                    src={url + "images/services/custom-development.webp"}
                    alt="Custom Development"
                  />
                </div>
                <Link to="/custom-software-development" className="srvc-title">
                  <p>Custom Development </p>
                </Link>
                <div className="srvc-desc">
                  <span style={{ display: displayText1 }}>
                    <p>
                     Delivers robust web and mobile applications, SaaS platforms, 
                     MVPs, and ERP extensions built to support evolving business 
                     models and long-term scalability.
                    </p>
                  </span>
                  {window.innerWidth < 768 && (
                    <button
                      onClick={handleButtonClick1}
                      id="myBtn"
                      className="myBtn"
                    >
                      {buttonText1}{" "}
                      <FontAwesomeIcon icon={faArrowRight} className="i" />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 service">
                <div className="srvc-img">
                  <img
                    loading="lazy"
                    src={url + "images/services/ai.webp"}
                    alt="AI-Powered Projects"
                  />
                </div>
                <Link to="/ai-development"  className="srvc-title">
                  <p> AI & Automation</p>
                </Link>
                <div className="srvc-desc">
                  <span style={{ display: displayText2 }}>
                    <p>
                      Enables smarter operations through workflow automation, predictive 
                      insights, AI-powered decision support, and intelligent system 
                      integrations that reduce manual effort and improve accuracy.
                      {/* Grab your potential customer’s attention with creative &
                      consistent branding across all platforms to stand out in
                      the crowd. So, <span className="bold">Be Bold</span>,{" "}
                      <span className="light">Be Light</span>,{" "}
                      <span className="italic">Be Italic</span>, but never be{" "}
                      <span className="regular">Regular</span>. */}
                    </p>
                  </span>
                  {window.innerWidth < 768 && (
                    <button
                      onClick={handleButtonClick2}
                      id="myBtn"
                      className="myBtn"
                    >
                      {buttonText2}{" "}
                      <FontAwesomeIcon icon={faArrowRight} className="i" />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 service">
                <div className="srvc-img">
                  <img
                    loading="lazy"
                    src={url + "images/services/resource-augmentation.jpg"}
                    alt="Resource Augmentation"
                  />
                </div>
                 <Link to="/offshore-software-development" className="srvc-title">
                  <p> Resource Augmentation</p>
                </Link>
                <div className="srvc-desc">
                  <span style={{ display: displayText2 }}>
                    <p>
                      Provides on-demand access to experienced developers, engineers, 
                      AI specialists, and product teams, allowing businesses to scale 
                      technical capacity quickly without the overhead of permanent 
                      hiring.
                    </p>
                  </span>
                  {window.innerWidth < 768 && (
                    <button
                      onClick={handleButtonClick2}
                      id="myBtn"
                      className="myBtn"
                    >
                      {buttonText2}{" "}
                      <FontAwesomeIcon icon={faArrowRight} className="i" />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 service">
                <div className="srvc-img">
                  <img
                    loading="lazy"
                    src={url + "images/services/app-web-dev.webp"}
                    alt="App & Web Development"
                  />
                </div>
                <div className="srvc-title">
                  <p>App & Web Design and Development </p>
                </div>
                <div className="srvc-desc">
                  <span style={{ display: displayText1 }}>
                    <p>
                     Focuses on creating digital destinations that combine user-centric 
                     design with seamless functionality. From mobile apps to enterprise 
                     portals and websites, every experience is crafted to align with brand 
                     identity and user expectations.
                    </p>
                  </span>
                  {window.innerWidth < 768 && (
                    <button
                      onClick={handleButtonClick1}
                      id="myBtn"
                      className="myBtn"
                    >
                      {buttonText1}{" "}
                      <FontAwesomeIcon icon={faArrowRight} className="i" />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 service">
                <div className="srvc-img">
                  <img
                    loading="lazy"
                    src={url + "images/services/smm.jpg"}
                    alt="Social Media Marketing"
                  />
                </div>
                <div className="srvc-title">
                  <p>Performance Marketing</p>
                </div>
                <div className="srvc-desc">
                  <span style={{ display: displayText3 }}>
                    <p>
                      Turns digital assets into performance channels through data-driven campaigns, engaging content, and lead-focused strategies designed to drive real business outcomes, not just visibility.
                    </p>
                  </span>
                  {window.innerWidth < 768 && (
                    <button
                      onClick={handleButtonClick3}
                      id="myBtn"
                      className="myBtn"
                    >
                      {buttonText3}{" "}
                      <FontAwesomeIcon icon={faArrowRight} className="i" />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 service">
                <div className="srvc-img">
                  <img
                    loading="lazy"
                    src={url + "images/services/branding.webp"}
                    alt="Branding"
                  />
                </div>
                <div className="srvc-title">
                  <p>Branding</p>
                </div>
                <div className="srvc-desc">
                  <span style={{ display: displayText4 }}>
                    <p>
                      Shapes clear, consistent, and memorable brand identities. From visual 
                      systems to strategic positioning, brands are built to stand out, 
                      connect with audiences, and remain relevant in a competitive digital 
                      landscape.
                    </p>
                  </span>
                  {window.innerWidth < 768 && (
                    <button
                      onClick={handleButtonClick4}
                      id="myBtn"
                      className="myBtn"
                    >
                      {buttonText4}{" "}
                      <FontAwesomeIcon icon={faArrowRight} className="i" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`color-black panel-3`}
        >
          <h5 className="row panel-text">
            Together, these capabilities form an integrated digital ecosystem, designed to help businesses build, scale, and lead with confidence in a rapidly changing digital world.
          </h5>
          <div className="divider"></div>
        </div>
      </div>
    </section>
  );
};

export default Section2;
